import classNames from 'classnames';
import React, {useState} from 'react';
import {useDropzone} from 'react-dropzone';
import 'Shared/components/FileDropzone.sass';

type FileDropzoneProps = {
  onSelectFile: (file: File) => void;
  className?: string;
  file?: File;
  useCase?: string;
};

type FileUploadErrors = {
  selectedFormError: string | boolean;
  fileError: string | boolean;
};
const MAX_SIZE = 10485760; // 10 MB in bytes.

const FileDropzone = (props: FileDropzoneProps) => {
  const {className, file, onSelectFile, useCase} = props;
  const [errors, setErrors] = useState<FileUploadErrors>({selectedFormError: false, fileError: false});
  const [isDraggingFile, setIsDraggingFile] = useState(false);

  const onDropAccepted = (acceptedFiles: File[]) => {
    onSelectFile(acceptedFiles[0]);
    setErrors({
      ...errors,
      fileError: false,
    });
  };

  const onDropRejected = (acceptedFiles: File[]) => {
    setErrors({
      ...errors,
      fileError: acceptedFiles[0].size > MAX_SIZE ? 'File Exceeds Maximum Allowed Size.' : 'File Format Not Accepted.',
    });
  };

  const onDragOver = () => {
    setIsDraggingFile(true);
  };

  const onDragLeave = () => {
    setIsDraggingFile(false);
  };

  const {getRootProps, getInputProps} = useDropzone({
    onDragOver,
    onDragLeave,
    onDropAccepted,
    onDropRejected,
    maxSize: MAX_SIZE,
    accept:
      useCase === 'A360_ENROLLMENT_FILE'
        ? '.xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        : 'image/jpg, image/jpeg, image/tif, image/tiff, application/pdf',
  });

  const getFileMessage = () => {
    if (file) {
      return file.name;
    } else if (errors.fileError) {
      return errors.fileError;
    } else if (isDraggingFile) {
      return 'Drop File Here';
    } else {
      return 'Drop File Here Or Click To Browse';
    }
  };

  return (
    <section className="file-dropzone">
      <div
        {...getRootProps({
          className: classNames(
            {'file-dropzone__file-drop-container': !isDraggingFile},
            {'file-dropzone__file-drop-container--active': isDraggingFile}
          ),
        })}
      >
        <input {...getInputProps()} type="file" multiple={false} hidden />
        <div className="file-dropzone__dropzone-message">
          <i className="agent-registration__file-watermark fa fa-4x fa-file-alt" />
          {getFileMessage()}
        </div>
      </div>
    </section>
  );
};

export default FileDropzone;
